/* ── Boss Bidet Revolution Landing Page JS ── */

(function () {
  'use strict';

  /* ── VARIANT SWITCHER ── */
  function initVariants() {
    var btns = document.querySelectorAll('.bb-variant-btn');
    var heroImg = document.getElementById('bb-hero-img');
    var nameDisplay = document.getElementById('bb-variant-name');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var src = btn.getAttribute('data-img');
        var name = btn.getAttribute('data-name');
        if (heroImg && src) heroImg.src = src;
        if (nameDisplay && name) nameDisplay.textContent = name;
      });
    });
  }

  /* ── QUANTITY SELECTOR ── */
  function initQty() {
    var input = document.getElementById('bb-qty-input');
    var dec   = document.getElementById('bb-qty-dec');
    var inc   = document.getElementById('bb-qty-inc');
    if (!input || !dec || !inc) return;

    dec.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
    });

    inc.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });

    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) input.value = 1;
    });

    input.addEventListener('blur', function () {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) input.value = 1;
    });
  }

  /* ── ADD TO CART ── */
  function initAddToCart() {
    var btn = document.getElementById('bb-add-btn');
    if (!btn) return;

    var checkoutUrl = btn.getAttribute('data-checkout-url') ||
                      'https://shop.bossbidet.com/discount/CHATGPT15?redirect=/checkout';

    btn.addEventListener('click', function () {
      var selectedBtn = document.querySelector('.bb-variant-btn.active');
      var variantId   = selectedBtn ? selectedBtn.getAttribute('data-variant-id') : null;
      var qty         = parseInt((document.getElementById('bb-qty-input') || {}).value, 10) || 1;

      /* Guard: no variant ID — fall back to direct link */
      if (!variantId) {
        window.location.href = checkoutUrl;
        return;
      }

      btn.disabled    = true;
      btn.textContent = 'Adding to cart…';

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      })
      .then(function (res) {
        if (!res.ok) { throw new Error('cart/add failed'); }
        return res.json();
      })
      .then(function () {
        window.location.href = checkoutUrl;
      })
      .catch(function () {
        /* On error fall back to direct checkout link */
        window.location.href = checkoutUrl;
      });
    });
  }

  /* ── COUNTDOWN TIMER ── */
  function initCountdown() {
    var h = document.getElementById('bb-cd-h');
    var m = document.getElementById('bb-cd-m');
    var s = document.getElementById('bb-cd-s');
    if (!h || !m || !s) return;

    var total = 11 * 3600 + 59 * 60;
    function tick() {
      total = Math.max(0, total - 1);
      h.textContent = String(Math.floor(total / 3600)).padStart(2, '0');
      m.textContent = String(Math.floor((total % 3600) / 60)).padStart(2, '0');
      s.textContent = String(total % 60).padStart(2, '0');
    }
    setInterval(tick, 1000);
  }

  /* ── VIDEO — inline YouTube embed with autoplay ── */
  function initVideo() {
    var wrap = document.getElementById('bb-video-wrap');
    var btn  = document.getElementById('bb-watch-btn');
    if (!wrap) return;

    /* Fallback to known video ID if attribute is missing/empty */
    var raw     = wrap.getAttribute('data-video-url') || 'https://www.youtube.com/watch?v=OGryPh0-Ktw';
    var videoId = '';
    var m = raw.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{11})/);
    if (m) { videoId = m[1]; }
    else if (/^[A-Za-z0-9_-]{11}$/.test(raw.trim())) { videoId = raw.trim(); }

    if (!videoId) videoId = 'OGryPh0-Ktw'; /* hard fallback */

    function embedVideo() {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + videoId +
                   '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      iframe.title          = 'Boss Bidet Revolution';
      iframe.frameBorder    = '0';
      iframe.allow          = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.style.cssText  = 'width:100%;aspect-ratio:16/9;display:block;border:none;border-radius:10px;';
      wrap.style.aspectRatio = '16/9';
      wrap.style.cursor      = 'default';
      wrap.innerHTML = '';
      wrap.appendChild(iframe);
      wrap.removeEventListener('click', embedVideo);
      if (btn) btn.removeEventListener('click', embedVideo);
    }

    wrap.addEventListener('click', embedVideo);
    if (btn) btn.addEventListener('click', embedVideo);
  }

  /* ── FAQ ACCORDION ── */
  function initFaq() {
    var questions = document.querySelectorAll('.bb-faq-q');
    questions.forEach(function (q) {
      q.addEventListener('click', function () {
        var answer = q.nextElementSibling;
        var icon   = q.querySelector('.bb-faq-icon');
        var isOpen = answer.style.display === 'block';

        document.querySelectorAll('.bb-faq-a').forEach(function (a) { a.style.display = 'none'; });
        document.querySelectorAll('.bb-faq-icon').forEach(function (i) {
          i.textContent  = '+';
          i.style.transform = 'rotate(0deg)';
        });

        if (!isOpen) {
          answer.style.display = 'block';
          if (icon) { icon.textContent = '+'; icon.style.transform = 'rotate(45deg)'; }
        }
      });
    });
  }

  /* ── VARIANT NAME TWO-LINE SPLIT ── */
  function initVariantNameSplit() {
    document.querySelectorAll('.bb-variant-btn span').forEach(function (el) {
      var parts = el.textContent.trim().split(' ');
      if (parts.length >= 2) {
        el.innerHTML = parts[0] + '<br>' + parts.slice(1).join(' ');
      }
    });
  }

  /* ── REVIEWS CAROUSEL ── */
  function initReviewsCarousel() {
    var track   = document.getElementById('bb-reviews-track');
    var prevBtn = document.getElementById('bb-rev-prev');
    var nextBtn = document.getElementById('bb-rev-next');
    if (!track || !prevBtn || !nextBtn) return;

    var cards   = track.querySelectorAll('.bb-review-card');
    var total   = cards.length;
    var current = 0;

    function perView() {
      return window.innerWidth <= 768 ? 1 : 3;
    }

    function getCardWidth() {
      if (!cards[0]) return 0;
      /* card width + gap (20px) */
      return cards[0].getBoundingClientRect().width + 20;
    }

    function maxIndex() {
      return Math.max(0, total - perView());
    }

    function update() {
      var offset = current * getCardWidth();
      track.style.transform = 'translateX(-' + offset + 'px)';
      prevBtn.disabled = current === 0;
      nextBtn.disabled = current >= maxIndex();
    }

    prevBtn.addEventListener('click', function () {
      if (current > 0) { current--; update(); }
    });

    nextBtn.addEventListener('click', function () {
      if (current < maxIndex()) { current++; update(); }
    });

    /* Touch / swipe support */
    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (dx < -40 && current < maxIndex()) { current++; update(); }
      if (dx >  40 && current > 0)          { current--; update(); }
    }, { passive: true });

    window.addEventListener('resize', function () {
      current = Math.min(current, maxIndex());
      update();
    });

    update();
  }

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', function () {
    initVariants();
    initQty();
    initAddToCart();
    initCountdown();
    initVideo();
    initFaq();
    initVariantNameSplit();
    initReviewsCarousel();
  });

})();
